import { Point } from "react-simple-maps";

export const MapUtils = {
  convertCoordinateStringToPoint: (coordinateString: string): Point => {
    return Array.from(coordinateString.split(","), Number) as Point;
  },
};
